/**
 * Static content for the Notice of Admission (NOA) Order form.
 * Discipline keys / limitation tags are UI defaults — clinicians may add more.
 */

export const DEFAULT_FUNCTIONAL_LIMITATIONS = [
  "Ambulation",
  "Amputation",
  "Paralysis",
  "Legally Blind",
  "Endurance",
  "Hearing",
  "Speech",
  "Vision",
  "Dyspnea With Minimal Exertion",
  "Contracture",
  "Bowel/Bladder (Incontinence)",
  "Other",
];

export const DEFAULT_VISIT_DISCIPLINES = [
  { discipline: "SN", label: "SN — Skilled Nursing" },
  { discipline: "PT", label: "PT — Physical Therapy" },
  { discipline: "OT", label: "OT — Occupational Therapy" },
  { discipline: "ST", label: "ST — Speech Therapy" },
  { discipline: "HHA", label: "HHA — Home Health Aide" },
];

export const CERTIFICATION_ITEMS = [
  {
    key: "certHomeboundSkilled",
    label:
      "The patient is homebound and in need of intermittent skilled nursing care, physical therapy, speech-language pathology services, or continues to need occupational therapy.",
  },
  {
    key: "certUnderPhysicianCare",
    label:
      "A plan of care has been established and is periodically reviewed by a physician. The patient is under the care of a physician.",
  },
];

/** Create a client-side id that fits the backend max length of 64. */
export const newVisitRowId = () =>
  `vf_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;

/**
 * Home-health frequency shorthand like "2w1" / "1w8" → visits (n × weeks).
 * Unknown patterns return 0 so clinicians can still set Total Visits manually.
 */
export const parseFrequencyVisits = (raw) => {
  if (!raw || typeof raw !== "string") return 0;
  const m = raw.trim().toLowerCase().match(/^(\d+)\s*[xw]\s*(\d+)$/i);
  if (!m) return 0;
  return Number(m[1]) * Number(m[2]);
};

export const sumVisitFrequencies = (row) => {
  const a = parseFrequencyVisits(row?.freq1);
  const b = parseFrequencyVisits(row?.freq2);
  const c = parseFrequencyVisits(row?.freq3);
  const total = a + b + c;
  return total > 0 ? total : row?.totalVisits || null;
};

export const defaultVisitFrequencies = () =>
  DEFAULT_VISIT_DISCIPLINES.map((d) => ({
    id: newVisitRowId(),
    discipline: d.discipline,
    freq1: "",
    freq2: "",
    freq3: "",
    totalVisits: null,
  }));
